// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EyeInvisibleOutlinedSvg from "@fishx/icons-svg/es/asn/EyeInvisibleOutlined";
import FishxIcon from '../components/FishxIcon';

var EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: EyeInvisibleOutlinedSvg
  }));
};

EyeInvisibleOutlined.displayName = 'EyeInvisibleOutlined';
export default React.forwardRef(EyeInvisibleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/EyeInvisibleOutlined.js
// module id = 2649
// module chunks = 0